import {
  CONTENT_SUBMISSION_ANALYTICS_BUTTONS as ANALYTICS_BUTTONS,
  CONTENT_SUBMISSION_ANALYTICS_SCREENS as ANALYTICS_SCREENS,
} from '@/lib/analytics/analyticsConstants';
import useTrackButtonEvent from '@/hooks/analytics/use-track-button-event/useTrackButtonEvent';

export type ResizeAnalyticsContext = {
  campaignId?: string;
  creatorId?: string;
  flowId?: string;
};

function useResizeAnalytics({
  campaignId,
  creatorId,
  flowId,
}: ResizeAnalyticsContext) {
  const {pressed} = useTrackButtonEvent();

  const track = (buttonName: string, tab = '') =>
    pressed({
      button_name: buttonName,
      screen_name: ANALYTICS_SCREENS.ASSET_DETAIL,
      campaign_id: campaignId,
      creator_id: creatorId,
      flow_id: flowId,
      tab,
    });

  return {
    trackStarted: (targetResolution: string) =>
      track(ANALYTICS_BUTTONS.RESIZE_STARTED, targetResolution),
    trackLimitReached: () => track(ANALYTICS_BUTTONS.RESIZE_LIMIT_REACHED),
    trackIneligible: () => track(ANALYTICS_BUTTONS.RESIZE_INELIGIBLE),
    trackPlaygroundCta: () => track(ANALYTICS_BUTTONS.RESIZE_PLAYGROUND_CTA),
    trackContactSales: () => track(ANALYTICS_BUTTONS.RESIZE_CONTACT_SALES),
    trackPlay: () => track(ANALYTICS_BUTTONS.RESIZE_GENERATION_PLAY),
    trackDownload: () => track(ANALYTICS_BUTTONS.RESIZE_GENERATION_DOWNLOAD),
  };
}

export default useResizeAnalytics;
